var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsAiassistantScenarioDataQuery = function SvgNewcsAiassistantScenarioDataQuery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 120 120"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "newcs_aiassistant_scenario_data_query_svg__b",
    x1: 20,
    x2: 100,
    y1: 20,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#93C5FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2563EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "newcs_aiassistant_scenario_data_query_svg__d",
    x1: 20,
    x2: 100,
    y1: 20,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFF",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "newcs_aiassistant_scenario_data_query_svg__e",
    x1: 20,
    x2: 70,
    y1: 20,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "newcs_aiassistant_scenario_data_query_svg__f",
    x1: 60,
    x2: 60,
    y1: 80,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "newcs_aiassistant_scenario_data_query_svg__g",
    x1: 60,
    x2: 60,
    y1: 20,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF",
    stopOpacity: 0.45
  })), /*#__PURE__*/React.createElement("filter", {
    id: "newcs_aiassistant_scenario_data_query_svg__c",
    width: 120,
    height: 120,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    stdDeviation: 6
  })), /*#__PURE__*/React.createElement("filter", {
    id: "newcs_aiassistant_scenario_data_query_svg__a",
    width: 112,
    height: 112,
    x: 4,
    y: 8,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 8,
    floodColor: "#1D4ED8",
    floodOpacity: 0.25,
    stdDeviation: 8
  })), /*#__PURE__*/React.createElement("filter", {
    id: "newcs_aiassistant_scenario_data_query_svg__h",
    width: "140%",
    height: "140%",
    x: "-20%",
    y: "-20%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 1.5,
    floodColor: "#000",
    floodOpacity: 0.12,
    stdDeviation: 1.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#newcs_aiassistant_scenario_data_query_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    x: 20,
    y: 20,
    fill: "url(#newcs_aiassistant_scenario_data_query_svg__b)",
    rx: 24
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#newcs_aiassistant_scenario_data_query_svg__c)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 20,
    fill: "#FFF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 80,
    r: 16,
    fill: "#1E3A8A",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 85,
    r: 12,
    fill: "#2563EB",
    fillOpacity: 0.35
  })), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    x: 20,
    y: 20,
    fill: "url(#newcs_aiassistant_scenario_data_query_svg__d)",
    rx: 24
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    x: 20,
    y: 20,
    fill: "url(#newcs_aiassistant_scenario_data_query_svg__e)",
    rx: 24
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    x: 20,
    y: 20,
    fill: "url(#newcs_aiassistant_scenario_data_query_svg__f)",
    rx: 24
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.8,
    height: 78.8,
    x: 20.6,
    y: 20.6,
    stroke: "url(#newcs_aiassistant_scenario_data_query_svg__g)",
    strokeWidth: 1.2,
    rx: 23.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    x: 22,
    y: 22,
    stroke: "#FFF",
    strokeOpacity: 0.2,
    strokeWidth: 0.5,
    rx: 22
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#newcs_aiassistant_scenario_data_query_svg__h)",
    transform: "translate(40 42)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 8,
    fill: "#FFF",
    fillOpacity: 0.5,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 14)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 9,
    fill: "#FFF",
    fillOpacity: 0.95,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 4.5,
    r: 2,
    fill: "#3B82F6",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    d: "M-5 2.5h4m-4 4h4"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 8,
    y: 30,
    fill: "#FFF",
    fillOpacity: 0.5,
    rx: 4
  }))));
};
export default SvgNewcsAiassistantScenarioDataQuery;